import { AppText } from "@otomoro/components/shared/AppText"
import { AppTitle } from "@otomoro/components/shared/AppTitle"
import { SanityImage } from "@otomoro/components/shared/SanityImage"
import { PortableText, PortableTextComponents } from "next-sanity"
import { styles, StepVariants } from "./Step.css"
import clsx from "clsx"

interface StepProps extends StepVariants {
  title: string
  description: any
  thumbnail: any
  openIdx: number
  index: number
}

export const StepDesktop: React.FC<StepProps> = ({ title, description, thumbnail }) => {
  const descriptionComponent = {
		block: {
			normal: ({ children }: any) => (
				<AppText as="p" size="base" color="white" weight="medium" className="mt-[1.5rem] pb-2 lg:mt-[0.5rem] lg:pb-0 md:max-w-[42ch]">
					{children}
				</AppText>
			),
		},
		marks: {
			highlight: ({ children }: any) => <span className="text-mainPink">{children}</span>,
		},
	} as PortableTextComponents

  const { stepContent } = styles()

  return (
    <li className={clsx(stepContent())}>
      <SanityImage className="w-full object-cover h-full" figureClass="lg: aspectrounded-[0.56rem] lg:rounded-[1.2rem] lg:aspect-[271/162] overflow-hidden max-h-[20rem] w-full col-span-2 self-center" image={thumbnail.image} alt={thumbnail.alt} sizes='30vw' />
      <div className="h-fit w-full col-span-2">
        <AppTitle as="h3" variant="h3" color="white" textTransform="uppercase">{title}</AppTitle>
        <PortableText value={description} components={descriptionComponent}/>
      </div>
    </li>
  )
}
